function User4() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9975 22C17.0613 22 21.9951 17.0667 21.9951 10.9975C21.9951 4.93379 17.0618 0 10.9975 0C4.9333 0 0 4.9333 0 10.9975C0 17.0667 4.9333 22 10.9975 22V22ZM0.819598 10.9975C0.819598 5.39295 5.38465 0.819598 10.9975 0.819598C16.6104 0.819598 21.1755 5.3929 21.1755 10.9975C21.1755 13.4533 20.3009 15.7028 18.8517 17.46C17.6005 14.27 14.4655 12.1083 10.9975 12.1083C7.5296 12.1083 4.3946 14.2671 3.135 17.4517C1.694 15.6917 0.8195 13.4422 0.8195 10.9975H0.819598Z"
        fill="white"
      />
      <path
        d="M10.9978 11.4126C13.2061 11.4126 14.999 9.61961 14.999 7.41136C14.999 5.20311 13.206 3.40186 10.9978 3.40186C8.78953 3.40186 6.98828 5.20311 6.98828 7.41136C6.98828 9.6225 8.78953 11.4126 10.9978 11.4126Z"
        fill="white"
      />
    </svg>
  );
}

export default User4;
